import styled, { css } from "styled-components";
import { CoreButtonAlt } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import { Typography } from "../../Typography";

type ContainerProps = {
  $hasError: boolean;
  $fullWidth: boolean;
  $textAlign: CoreButtonAlt.TextAlign;
};

export const Container = styled.label<ContainerProps>`
  ${({ $hasError, $fullWidth, $textAlign }) => {
    const { tokens } = useDesignTokens();
    const { buttonAlt } = tokens;

    return [
      css`
        display: inline-flex;
        align-items: center;
        border-width: ${buttonAlt.stroke.width.base};
        border-style: ${buttonAlt.stroke.style};
        border-color: ${buttonAlt.stroke.color.base};
        border-radius: ${buttonAlt.radius};
        min-width: ${buttonAlt.minWidth};
        min-height: ${buttonAlt.minHeight.lg};
        padding-top: ${buttonAlt.padding.top};
        padding-left: ${buttonAlt.padding.left};
        padding-right: ${buttonAlt.padding.right};
        padding-bottom: ${buttonAlt.padding.bottom};
        color: ${buttonAlt.color.base};
        background: ${buttonAlt.backgroundColor.base};
        cursor: pointer;

        &:has(:focus-visible) {
          outline-width: ${buttonAlt.focusRing.width};
          outline-style: ${buttonAlt.focusRing.style};
          outline-color: ${buttonAlt.focusRing.color};
          outline-offset: ${buttonAlt.focusRing.offset};
        }

        &:hover {
          color: ${buttonAlt.color.hover};
          background: ${buttonAlt.backgroundColor.hover};
        }

        &:has(:checked) {
          border-color: ${buttonAlt.stroke.color.active};
          color: ${buttonAlt.color.active};
          background: ${buttonAlt.backgroundColor.active};
        }
      `,
      $fullWidth &&
        css`
          width: 100%;
        `,
      $textAlign === "center" &&
        css`
          text-align: center;
          justify-content: center;
        `,
      $hasError &&
        css`
          border-width: ${buttonAlt.stroke.width.error};
          border-color: ${buttonAlt.stroke.color.error};
        `,
    ];
  }}
`;

export const Text = styled(Typography)`
  overflow-wrap: anywhere;
`;
